<template>
  <div id="app" class="full-h" v-watermark="{text:userName}">
    <router-view/>
  </div>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        name:"App",
        computed: {
            ...mapState({
                userName:state => state.user.team_name+'-'+state.user.name,
            }),
        },
    };
</script>
<style lang="scss" scoped>
  /*@import './assets/css/global.css';*/
</style>
